import {getPrivateAxios} from '../../libs';
import {GuideShare} from './types';

interface GuideShareUpdateDto extends GuideShare {
  guideId: string;
}

export const fetchGuideShareUpdate = async (updateDto: GuideShareUpdateDto) => {
  const {data} = await getPrivateAxios().patch<GuideShareUpdateDto>(
    `/guides/${updateDto.guideId}/share`,
    {
      type: updateDto.type,
    },
  );
  return data;
};
